"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { useInvalidateServerComponent } from "@/src/components/server/client-provider";
import { Button } from "@/src/components/shadcn/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/src/components/shadcn/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/src/components/shadcn/ui/select";
import { ValerieCard } from "@/src/components/valerie-card";
import { useAthenaCoverageResolution, useResolveAthenaCoverage } from "@/src/lib/data-fetchers/athena-coverage-resolution-fetchers";
import type { AthenaCoverageChoice, AthenaCoverageResolutionPreview } from "@/src/models/athena-coverage-resolution";
function CoverageResolutionForm(t0) {
  const $ = _c(48);
  const {
    mutation,
    preview,
    onComplete
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      policyKey: ""
    }];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [choices, setChoices] = useState(t1);
  let t2;
  if ($[1] !== mutation || $[2] !== preview.candidates) {
    t2 = source => {
      const candidates = preview.candidates.filter(candidate => candidate.source === source).toSorted(_temp);
      setChoices(candidates.map(_temp2));
      mutation.reset();
    };
    $[1] = mutation;
    $[2] = preview.candidates;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const acceptSource = t2;
  let t3;
  if ($[4] !== choices || $[5] !== mutation) {
    t3 = (index, choice) => {
      setChoices(choices.map((current, row) => row === index ? choice : current));
      mutation.reset();
    };
    $[4] = choices;
    $[5] = mutation;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const updateChoice = t3;
  let t4;
  if ($[7] !== choices || $[8] !== mutation || $[9] !== onComplete || $[10] !== preview.version) {
    t4 = () => mutation.mutate({
      version: preview.version,
      choices
    }, {
      onSuccess: onComplete
    });
    $[7] = choices;
    $[8] = mutation;
    $[9] = onComplete;
    $[10] = preview.version;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleSubmit = t4;
  let t5;
  if ($[12] !== choices || $[13] !== preview.candidates) {
    let t6;
    if ($[15] !== preview.candidates) {
      t6 = choice_0 => !choice_0.policyKey || !preview.candidates.find(candidate_0 => candidate_0.key === choice_0.policyKey)?.packageId;
      $[15] = preview.candidates;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    t5 = choices.some(t6);
    $[12] = choices;
    $[13] = preview.candidates;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const incomplete = t5;
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = ["valerie", "athena"];
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== acceptSource || $[19] !== mutation.isPending || $[20] !== preview.candidates) {
    t7 = <div className="grid gap-3 sm:grid-cols-2">{(t6 as const).map(source_0 => {
        const candidates_0 = preview.candidates.filter(candidate_1 => candidate_1.source === source_0);
        return <ValerieCard key={source_0} title={source_0 === "valerie" ? "Valerie" : "Athena"} contentClassName="space-y-2">{candidates_0.length === 0 && <p className="text-sm text-muted-foreground">No coverage</p>}{candidates_0.map(_temp3)}<Button type="button" variant="outline" size="sm" disabled={mutation.isPending || candidates_0.length === 0 || candidates_0.length > 2 || candidates_0.length > 1 && candidates_0.some(_temp4) || candidates_0.some(_temp5)} onClick={() => acceptSource(source_0)}>Accept {source_0 === "valerie" ? "VH" : "Athena"}</Button>{candidates_0.length > 2 && <p className="text-xs text-muted-foreground">Choose the applicable policies below.</p>}</ValerieCard>;
      })}</div>;
    $[18] = acceptSource;
    $[19] = mutation.isPending;
    $[20] = preview.candidates;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="text-sm text-muted-foreground">Choose Valerie or Athena for each primary and secondary policy. Each selection includes all of that policy's subscriber details.</p>;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== preview.candidates) {
    t9 = preview.candidates.some(_temp6) && <p className="text-sm text-muted-foreground">An unresolved Valerie plan cannot be written yet. Choose the correct Athena policy, or correct it in Athena and refresh.</p>;
    $[23] = preview.candidates;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== choices || $[26] !== mutation.isPending || $[27] !== preview.candidates || $[28] !== updateChoice) {
    t10 = choices.map((choice_1, index_0) => {
      const policy = preview.candidates.find(candidate_6 => candidate_6.key === choice_1.policyKey);
      return <div key={index_0} className="space-y-2 rounded-md border p-3"><p className="font-medium">{index_0 === 0 ? "Primary" : "Secondary"}</p><Select value={choice_1.policyKey} disabled={mutation.isPending} onValueChange={key_0 => updateChoice(index_0, {
          policyKey: key_0
        })}><SelectTrigger className="bg-background" aria-label={`${index_0 === 0 ? "Primary" : "Secondary"} policy`}><SelectValue placeholder="Choose policy" /></SelectTrigger><SelectContent>{preview.candidates.map(candidate_7 => <SelectItem key={candidate_7.key} value={candidate_7.key} disabled={!candidate_7.packageId || candidate_7.selfPay && choices.length > 1}>{candidate_7.source === "valerie" ? "VH" : "Athena"}: {candidate_7.label} · Package{" "}{candidate_7.packageId ?? "unresolved"}</SelectItem>)}</SelectContent></Select>{policy && <ValerieCard title="Selected coverage" contentClassName="space-y-1 text-sm"><p>{policy.label} · Package: {policy.packageId ?? "Unresolved"}</p><p>Member: {policy.memberId ?? "None"} · Group: {policy.groupNumber ?? "None"}</p><p>Subscriber:{" "}{[policy.subscriberGivenName, policy.subscriberFamilyName].filter(Boolean).join(" ") || "Name missing"}</p><p>DOB: {policy.subscriberDateOfBirth ?? "Missing"} · Sex: {policy.subscriberSex ?? "Missing"}</p><p>Relationship: {policy.relationshipToSubscriber ?? "None"}</p></ValerieCard>}{index_0 === 1 && <Button type="button" variant="ghost" size="sm" disabled={mutation.isPending} onClick={() => setChoices(choices.slice(0, 1))}>Remove secondary selection</Button>}</div>;
    });
    $[25] = choices;
    $[26] = mutation.isPending;
    $[27] = preview.candidates;
    $[28] = updateChoice;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== choices || $[31] !== mutation.isPending || $[32] !== preview.candidates) {
    t11 = choices.length === 1 && <Button type="button" variant="outline" size="sm" disabled={mutation.isPending || preview.candidates.some(candidate_8 => candidate_8.key === choices[0]?.policyKey && candidate_8.selfPay)} onClick={() => setChoices([...choices, {
      policyKey: ""
    }])}>Add secondary selection</Button>;
    $[30] = choices;
    $[31] = mutation.isPending;
    $[32] = preview.candidates;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <p className="text-sm text-muted-foreground">Sync updates Athena where needed and copies the confirmed coverage to this referral. Other chart policies may move later in the coverage order. Eligibility and network checks run on the confirmed selection.</p>;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== mutation.error) {
    t13 = mutation.error && <p role="alert" className="text-sm text-destructive">{mutation.error.message}</p>;
    $[35] = mutation.error;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  const t14 = mutation.isPending || incomplete;
  const t15 = mutation.isPending ? "Syncing insurance..." : "Sync and continue";
  let t16;
  if ($[37] !== handleSubmit || $[38] !== t14 || $[39] !== t15) {
    t16 = <Button type="button" onClick={handleSubmit} disabled={t14}>{t15}</Button>;
    $[37] = handleSubmit;
    $[38] = t14;
    $[39] = t15;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== t10 || $[42] !== t11 || $[43] !== t13 || $[44] !== t16 || $[45] !== t7 || $[46] !== t9) {
    t17 = <div className="space-y-4">{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t16}</div>;
    $[41] = t10;
    $[42] = t11;
    $[43] = t13;
    $[44] = t16;
    $[45] = t7;
    $[46] = t9;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  return t17;
}
function _temp6(candidate_5) {
  return !candidate_5.packageId;
}
function _temp5(candidate_3) {
  return !candidate_3.packageId;
}
function _temp4(candidate_4) {
  return candidate_4.selfPay;
}
function _temp3(candidate_2) {
  return <div key={candidate_2.key} className="text-sm"><p>{candidate_2.label}{" "}{candidate_2.casePolicy ? "(case policy)" : candidate_2.order === 1 ? "(primary)" : candidate_2.order === 2 ? "(secondary)" : `(order ${candidate_2.order ?? "unknown"})`}</p><p className="text-muted-foreground">Package: {candidate_2.packageId ?? "Unresolved"} · Member: {candidate_2.memberId ?? "None"}</p><p className="text-muted-foreground">{[candidate_2.subscriberGivenName, candidate_2.subscriberFamilyName].filter(Boolean).join(" ") || "Subscriber name missing"}{" "}· {candidate_2.subscriberDateOfBirth ?? "DOB missing"} · {candidate_2.subscriberSex ?? "Sex missing"}</p><p className="text-muted-foreground">Relationship: {candidate_2.relationshipToSubscriber ?? "None"} · Group:{" "}{candidate_2.groupNumber ?? "None"}</p></div>;
}
function _temp2(t0) {
  const {
    key
  } = t0;
  return {
    policyKey: key
  };
}
function _temp(left, right) {
  return (left.order ?? 3) - (right.order ?? 3);
}
export function AthenaCoverageResolutionDialog(t0) {
  const $ = _c(22);
  const {
    taskId
  } = t0;
  const [open, setOpen] = useState(false);
  const comparison = useAthenaCoverageResolution(taskId, open);
  const mutation = useResolveAthenaCoverage(taskId);
  const invalidateInstructions = useInvalidateServerComponent("getReferralInstructions");
  let t1;
  if ($[0] !== mutation) {
    t1 = nextOpen => {
      if (!mutation.isPending) {
        setOpen(nextOpen);
        mutation.reset();
      }
    };
    $[0] = mutation;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DialogTrigger asChild={true}><Button size="sm">Resolve insurance and continue</Button></DialogTrigger>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DialogHeader><DialogTitle>Resolve insurance differences</DialogTitle><DialogDescription>Review Valerie and live Athena coverage, then choose the values to sync.</DialogDescription></DialogHeader>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = comparison.isFetching || mutation.isPending;
  let t5;
  if ($[4] !== comparison) {
    t5 = () => comparison.refetch();
    $[4] = comparison;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <Button type="button" variant="outline" size="sm" disabled={t4} onClick={t5}>Refresh comparison</Button>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== comparison.data || $[10] !== comparison.error || $[11] !== comparison.isFetching || $[12] !== invalidateInstructions || $[13] !== mutation) {
    t7 = comparison.isFetching ? <p>Loading live insurance...</p> : comparison.error ? <p role="alert">{comparison.error.message}</p> : comparison.data ? <CoverageResolutionForm key={comparison.data.version} mutation={mutation} preview={comparison.data} onComplete={() => {
      setOpen(false);
      invalidateInstructions();
    }} /> : null;
    $[9] = comparison.data;
    $[10] = comparison.error;
    $[11] = comparison.isFetching;
    $[12] = invalidateInstructions;
    $[13] = mutation;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-3xl">{t3}{t6}{t7}</DialogContent>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== open || $[19] !== t1 || $[20] !== t8) {
    t9 = <Dialog open={open} onOpenChange={t1}>{t2}{t8}</Dialog>;
    $[18] = open;
    $[19] = t1;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}